import reportTemplateEdit from "@/views/report/ReportTemplateEdit";
import reportTemplateList from "@/views/report/ReportTemplateList";

const metaObject = { requiresAuth: true, roles: ['mmf'] };

export default [
    {
        path: "/report/reportTemplateEdit",
        name: "reportTemplateEdit",
        component: reportTemplateEdit,
        meta: metaObject
    },
    {
        path: "/report/reportTemplateList",
        name: "reportTemplateList",
        component: reportTemplateList,
        meta: metaObject
    }
]